import api from './axios';

const EndPoints = {
	login: `/merchant/auth/login`,
	signUp: `/merchant/auth/register`,
	verify: `/merchant/auth/verify`,
	resend: `/merchant/auth/verify/resend`,
	forgotPassword: `/merchant/auth/forgot/password`,
	changePassword: `/merchant/auth/reset/password`,
	twoFA: `/merchant/auth/2fa/authenticate`
};

export const SignUp = async (payload:unknown) => {
	const res = await api.post(EndPoints.signUp, payload);
	return res;
};
export const ResendVerificationMail = async (payload:unknown) => {
	const res = await api.post(EndPoints.resend, payload);
	return res;
};
export const VerifyEmailAddress = async (payload:unknown) => {
	const res = await api.post(EndPoints.verify, payload);
	return res;
};
export const login = async (payload:unknown) => {
	const res = await api.post(EndPoints.login, payload);
	return res;
};
export const forgotPassword = async (payload:unknown) => {
	const res = await api.post(EndPoints.forgotPassword, payload);
	return res;
};
export const changePassword = async (payload:unknown) => {
	const res = await api.post(EndPoints.changePassword, payload);
	return res;
};
export const twoFA = async (payload:unknown) => {
	const res = await api.post(EndPoints.twoFA, payload);
	return res;
};
